<template>
  <div>
    <header class="flex items-center">
      <div class="flex-none">
        <button class="btn" type="button" @click="goToPrevYear" :disabled="year === minYear">
          <svg width="24" height="24">
            <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
          </svg>
        </button>
      </div>

      <div class="flex 1 text-center w-full">
        <div class="mx-auto font-medium">
          {{ year }}
        </div>
      </div>

      <div class="flex-none">
        <button class="btn" type="button" @click="goToNextYear" :disabled="year === maxYear">
          <svg width="24" height="24">
            <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
          </svg>
        </button>
      </div>
    </header>

    <section class="month-grid">
      <div v-for="(month, value) in months" :key="month"
        class="p-2 cursor-pointer text-center"
        :class="{ 'is-disabled': isInThePast(value) }"
        @click="selectMonth(value)">
        {{ month }}
      </div>
    </section>
  </div>
</template>

<script>
import {
  MONTHS
} from '../../helpers/constants'

export default {
  props: ['dates'],
  data () {
    const thisYear = moment().year()

    return {
      value: this.dates[0] ? moment(this.dates[0]).startOf('month') : null,
      year: thisYear,
      minYear: thisYear,
      maxYear: thisYear + 2
    }
  },
  computed: {
    thisMoment () {
      return moment().startOf('month')
    },
    months () {
      return MONTHS
    },
    selectedMonthDisplay () {
      if (this.value) {
        return moment(this.value).format('MMMM YYYY')
      }

      return null
    }
  },
  methods: {
    goToPrevYear () {
      this.year = this.year - 1
    },
    goToNextYear () {
      this.year = this.year + 1
    },
    isInThePast (monthValue) {
      const today = moment()
      const thisYear = today.year()

      if (this.year < thisYear) {
        return true
      }

      if (this.year > thisYear) {
        return false
      }

      const thisMonth = today.month() + 1
      return monthValue < thisMonth
    },
    selectMonth (monthValue) {
      if (!this.isInThePast(monthValue)) {
        const newMoment = moment(`${this.year}-${monthValue}-01`, 'YYYY-MM-DD')

        this.value = newMoment
        this.$emit('input', [newMoment, null])
      } 
    }
  }
}
</script>


<style scoped>
.month-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  row-gap: 16px;
  column-gap: 16px;
}

.is-disabled {
  color: #B8B8B8;
  pointer-events: none;
}

.drop-panel {
  padding-left: 20px;
  padding-right: 20px;
  width: 270px;
  transform: translateX(-50%);
  left: 50%;
}
</style>
